module.exports = __webpack_public_path__ + "static/img/21.9202419.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hhwhyx/21.jpg
// module id = P5bO
// module chunks = 1